import { createFileRoute, redirect } from "@tanstack/react-router"

/** Trender is part of Nyckeltal now; this keeps old links working. */
export const Route = createFileRoute("/(app)/_auth/trends/")({
  beforeLoad: () => {
    throw redirect({ to: "/statistik", replace: true })
  },
})
